<template>
  <v-dialog v-model="dialog" eager max-width="600" scrollable>
    <template v-slot:activator="{ on }">
      <v-btn color="primary" class="px-6 mr-3" v-on="on" v-text="'Customise'" />
    </template>
    <v-card>
      <v-tabs background-color="primary" centered icons-and-text grow slider-color="white">
        <v-tab :key="'filters'" class="white--text">
          Filters
          <v-icon color="white">
            filter_list
          </v-icon>
        </v-tab>
        <v-tab :key="'columns'" class="white--text">
          Columns
          <v-icon color="white">
            view_column
          </v-icon>
        </v-tab>
        <!-- <v-tab :key="'favourites'" class="white--text">
          Favourites
          <v-icon color="white">
            favorite
          </v-icon>
        </v-tab> -->
        <v-tab-item :key="'filters'">
          <filter-component :filter-options="filterOptions" :active-filters="activeFilters" @addfilter="$emit('addfilter', $event)" @removefilter="$emit('removefilter', $event)" @filterstatus="$emit('filterstatus', $event)" />
        </v-tab-item>
        <v-tab-item :key="'columns'">
          <column-component :available-headers="availableHeaders" :visible-columns="visibleColumns" @newvisible="$emit('newvisible', $event)" />
        </v-tab-item>
        <!-- <v-tab-item :key="'favourites'">
          <v-flex ma-4>
            Favourites have been temporarily disabled
          </v-flex>
        </v-tab-item> -->
      </v-tabs>
    </v-card>
  </v-dialog>
</template>

<script>
import filterComponent from './filters.vue'
import columnComponent from './columns.vue'
export default {
  components: {
    filterComponent,
    columnComponent
  },
  props: {
    filterOptions: {
      type: Array,
      required: true
    },
    activeFilters: {
      type: Array,
      required: true
    },
    visibleColumns: {
      type: Array,
      required: true
    },
    availableHeaders: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      active: 'filters'
    }
  }
}
</script>
